// TODO: Update all colors to match mocks
export const publishStatusList = ['PUBLISHED', 'UNPUBLISHED'];
export const publishStatusColors = {
  UNPUBLISHED: 'inProgress',
  PUBLISHED: 'completed',
};

export const TERMS_LAST_UPDATED = '2024-10-31T00:00:00.000Z';

export const creationStatusList = ['DRAFT', 'ARCHIVED', 'COMPLETED', 'DELETED'];
export const creationStatusColors = {
  DRAFT: 'gray',
  ARCHIVED: 'gray',
  COMPLETED: 'gray',
  DELETED: 'failed',
};

export const processingStatusList = ['PROCESSING', 'COMPLETED', 'ERROR'];
export const processingStatusMap = {
  REQUESTED: 'PROCESSING',
  SCRAPED: 'PROCESSING',
  EDITED: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};

export const CHAT_MODELS = [
  'gpt-5-nano',
  'gpt-5-mini',
  'gpt-5',
  'claude-opus-4-6',
  'claude-sonnet-4-6',
  'claude-haiku-4-5-latest',
];
// TODO: Keep this in sync with the default model in src/voicetopics.js
export const DEFAULT_CHAT_MODEL = 'gpt-5-mini';

// TODO: Keep this in sync with the list in src/voicetopics.js
export const PUBLISHABLE_STATUS_LIST = ['COMPLETED', 'ARCHIVED'];

export const NO_TITLE = 'Untitled';
export const NO_CREATOR = 'Unknown';
export const NO_GROUP = 'Unassigned';

export const NO_GROUP_ID = 'none';
export const NO_LANGUAGE_ID = 'none';

export const TTS_SOURCES = {
  openai: 'OpenAI',
  google: 'Google',
  polly: 'AWS Polly',
  elevenlabs: 'ElevenLabs',
  cartesia: 'Cartesia',
  replicate: 'Replicate',
};

export const EMAIL_REGEX = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,63}$/; // eslint-disable-line

export const SAMPLE_AD = {
      id: 'ad-41514621ac9d',
      metadata: { title: 'Sample Ad' },
      audio: {
        id: 'audio-913ac68e7a8b',
        // TODO: This needs to be public? Use right environment not dev?
        uri: 'https://s3.us-east-1.amazonaws.com/voice-topics-audio-bucket-dev/audio-913ac68e7a8b.mp3',
        duration: 1.704,
      },
    };
